import styled from "styled-components";

import { SPACING } from "../../../utils/constants";
import Button from "../../../components/Button";

// The chart tooltip is `nowrap` for its value rows; these sentences must wrap instead of widening it.
export const Details = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.xs}px;
  max-width: 280px;
  padding: ${SPACING.sm}px ${SPACING.md}px;
  border-top: 1px solid var(--color-border-light);
  font-size: var(--text-xs);
  white-space: normal;
  color: var(--color-text-secondary);
`;

export const DetailLine = styled.span``;

export const WarningLine = styled.span`
  display: flex;
  align-items: center;
  gap: ${SPACING.xs}px;
`;

export const Note = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.xs}px;
  margin-top: ${SPACING.md}px;
  padding: ${SPACING.sm}px ${SPACING.md}px;
  border: 1px solid var(--color-warning-border);
  border-radius: 12px;
  background: var(--color-warning-background);
  color: var(--color-text-default);
  font-size: var(--text-sm);
`;

export const NoteRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${SPACING.sm}px;

  /* A flex item's default min-width is its content, so the sentence would push the button off the row. */
  > span {
    min-width: 0;
  }
`;

export const NoteButton = styled(Button)`
  flex-shrink: 0;
`;
